import {collection, doc, onSnapshot, orderBy, query, setDoc, where} from 'firebase/firestore'
import {ObjectMapper} from 'json-object-mapper'
import {sortBy} from 'lodash'
import useAsyncEffect from 'use-async-effect'
import {db} from '../fetchers/firebase'
import {Todo} from '../models/Todo'
import {sessionStore} from '../stores/session/sessionStore'
import {DB_USERS} from './consts'

const useCurrentTodos = () => {
  const user = sessionStore(state => state.user)
  const todos = sessionStore(state => state.todos)
  const setTodos = sessionStore(state => state.setTodos)

  useAsyncEffect(
    isMounted => {
      if (!user) {
        setTodos([])
        return
      }
      return onSnapshot(
        query(
          collection(db, `${DB_USERS}/${user!.id}/todos`),
          where('displayable', '==', true),
          orderBy('dueDate')
        ),
        querySnapshot => {
          if (isMounted()) {
            setTodos(
              sortBy(
                querySnapshot.docs.map(doc =>
                  ObjectMapper.deserialize(Todo, {id: doc.id, ...doc.data()})
                ),
                ''
              )
            )
          }
        }
      )
    },
    [user]
  )

  const markAllAsRead = async () => {
    for (const todo of todos) {
      await setDoc(doc(db, `${DB_USERS}/${user!.id}/todos/${todo.id}`), {read: true}, {merge: true})
    }
  }

  const toggleDone = async (todo: Todo) => {
    await setDoc(
      doc(db, `${DB_USERS}/${user!.id}/todos/${todo.id}`),
      {done: !todo.done},
      {merge: true}
    )
  }

  return {todos, markAllAsRead, toggleDone}
}

export default useCurrentTodos
